
 



 
 import {fs} from "Config/FsConfig";
 
    import AirQualityIndexViewPageData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityIndexViewPageData';


    //module PublicAirQualityIndexViewPageAppService {
    class PublicAirQualityIndexViewPageAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/PublicAirQualityIndexViewPageAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/PublicAirQualityIndexViewPageAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteLoadAirQualityIndexViewPage = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAirQualityIndexViewPageAppService/LoadAirQualityIndexViewPage`;
    public RouteLoadAirQualityIndexViewPage() : string {
        return this.ControllerUrl + "/"+"LoadAirQualityIndexViewPage";
    }
    public LoadAirQualityIndexViewPage(): JQuery.jqXHR<AirQualityIndexViewPageData> {
        return $.ajax({
                url: this.RouteLoadAirQualityIndexViewPage(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default PublicAirQualityIndexViewPageAppService;



